const analyticsEvt = {
  editorSaveClick: 'edx.ui.authoring.editor.save',
  editorCancelClick: 'edx.ui.authoring.editor.cancel',
  videoGalleryCancelClick: 'edx.ui.authoring.videogallery.cancel',
};

export default analyticsEvt;
